module.exports = __webpack_public_path__ + "static/img/testimony (41).9a29ffb1.jpg";